import React from 'react'
import { Target } from '@ccpgames/eve-web/components'
import Countdown, { CountdownTimeDelta, zeroPad } from 'react-countdown'
import cx from 'classnames'
import style from './CountDown.module.scss'

interface Props {
    title: string
    date: string
    onComplete?: () => void
    withTarget?: boolean
    classNames?: {
        completed?: string
        title?: string
        countdownContainer?: string
        timeUnit?: string
        number?: string
        label?: string
        wrapper?: string
    }
}

const renderer = (
    title: string,
    onComplete?: () => void,
    classNames: Props['classNames'] = {},
    withTarget = true
) => ({
    days,
    hours,
    minutes,
    seconds,
    completed,
}: CountdownTimeDelta): JSX.Element => {
    if (completed && onComplete) {
        onComplete()
    }
    const timeUnitStyles = cx(style.timeUnit, classNames.timeUnit || '')
    const numberStyles = cx(style.number, classNames.number || '')
    const labelStyles = cx(style.label, classNames.label || '')
    const completedStyles = cx(style.completed, classNames.completed || '')
    const wrapperStyles = cx(style.wrapper, classNames.wrapper)

    const body = (
        <div
            className={cx(
                style.countdownContainer,
                classNames.countdownContainer || ''
            )}
        >
            <div className={timeUnitStyles}>
                <span className={numberStyles}>{zeroPad(days)}</span>
                <span className={labelStyles}>Days</span>
            </div>
            <div className={timeUnitStyles}>
                <span className={numberStyles}>{zeroPad(hours)}</span>
                <span className={labelStyles}>Hours</span>
            </div>
            <div className={timeUnitStyles}>
                <span className={numberStyles}>{zeroPad(minutes)}</span>
                <span className={labelStyles}>Minutes</span>
            </div>
            <div className={timeUnitStyles}>
                <span className={numberStyles}>{zeroPad(seconds)}</span>
                <span className={labelStyles}>Seconds</span>
            </div>
        </div>
    )

    return (
        <div className={cx(wrapperStyles, { [completedStyles]: completed })}>
            <div className={cx(style.title, classNames.title || '')}>
                {title}
            </div>
            {withTarget ? <Target>{body}</Target> : body}
        </div>
    )
}

export const CountDown = ({
    title,
    date,
    onComplete,
    classNames,
    withTarget,
}: Props): JSX.Element => (
    <Countdown
        date={new Date(date)}
        renderer={renderer(title, onComplete, classNames, withTarget)}
    />
)
